import React, { FC, useEffect, useState } from 'react'
import { Badge } from 'antd'
import { useAnimatedWidth } from '../../../hooks/use-animated-width'
import styles from './animated-count-badge.module.scss'

type Props = {
  count: number
  scope: string
  label: string
  compact?: boolean
}

const AnimatedCountBadge: FC<Props> = ({ count, scope, label, compact }) => {
  const [rendered, setRendered] = useState({ scope, count })
  useEffect(() => {
    if (count) {
      setRendered({ scope, count })
      return
    }
    let active = true
    const timer = setTimeout(() => {
      if (active) setRendered({ scope, count: 0 })
    }, 180)
    return () => {
      active = false
      clearTimeout(timer)
    }
  }, [count, scope])
  const visibleCount = count || (rendered.scope === scope ? rendered.count : 0)
  const { contentRef, width } = useAnimatedWidth(scope, !!visibleCount)
  return visibleCount ? (
    <span
      key={scope}
      className={`${styles.wrapper}${compact ? ` ${styles.compact}` : ''}${count ? '' : ` ${styles.leaving}`}`}
      aria-label={`${label}: ${visibleCount}`}
      aria-hidden={count ? undefined : true}
      style={{ width }}
    >
      <span ref={contentRef} className={styles.number}>
        <Badge count={visibleCount} overflowCount={99} />
      </span>
    </span>
  ) : null
}

export default AnimatedCountBadge
